module.exports = __webpack_public_path__ + "img/ke.bbb6db06.svg";